/**
 * 시간대(time_slot) 영어를 한국어로 변환
 */
export function translateTimeSlot(timeSlot: string | null | undefined): string {
  if (!timeSlot) return ''

  const translations: Record<string, string> = {
    'morning': '오전',
    'afternoon': '오후',
    'evening': '저녁',
    'flexible': '시간 상관없음',
    'any': '시간 상관없음',
    // 이미 한국어인 경우
    '오전': '오전',
    '오후': '오후',
    '저녁': '저녁',
    '시간 상관없음': '시간 상관없음'
  }

  const lowerCase = timeSlot.toLowerCase()
  return translations[lowerCase] || timeSlot
}

/**
 * time_flexible 값에 따라 시간 표시 결정
 */
export function getTimeDisplayText(
  timeSlot: string | null | undefined,
  timeFlexible: boolean | null | undefined
): string {
  if (timeFlexible) {
    return '시간 상관없음'
  }
  return translateTimeSlot(timeSlot)
}
